import React from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { Layout } from "../components/Layout";
import { Header } from "../components/guide/Header";
import { Footer, Bye as FooterBye } from "../components/guide/Footer";
import { About3 } from "../components/guide/About";
import { SafeKids } from "../components/SafeKids/SafeKids";
import { ReadMore } from "../components/ReadMore";

import { Wrapper } from "../components/Wrapper";
import { HalfWrap, Picture, TwoOne } from "../components/Layout/Layout";

import {
  Card as TypeCard,
  Title as TypeTitle,
  Description as TypeDescription,
  Picture as TypePicture,
} from "../components/Cards/TypeCard";

import { Games, Game } from "../components/Game/Game";

import { Description } from "../components/Typography";

import { Quotes, Quote } from "../components/guide/Stream/3/WhatsWatch/Quote";

import { images } from "../images/guide/5";
import sound from "../images/guide/5/sound.mp3";
import { Character } from "../components/Game/Character";
import { characters } from "../images/guide/5/characters";
import { Test } from "../components/Test/5";
import { Audio } from "../components/Player/Audio";

const Guide = styled("main")(
  css({
    background: "linear-gradient(90deg, #7CFD34 0%, #1BC6AF 100%)",
    position: "relative",
    zIndex: 0,
    overflow: "hidden",
  })
);

const TwoOneHow = styled(TwoOne)(css({ mb: [30, 100] }));

const FooterStyled = styled(Footer)({
  borderRadius: 0,
});

const questions = [
  [
    [
      "В какой игре один из героев произносит фразу: “Жизнь за Нерзула!”?",
      ["StarCraft", "Warcraft III", "Warhammer", "Wartunder"],
      1,
      images[9],
    ],
    [
      "Какой из игр принадлежит знаменитая кампания “Битва за Эрафию”?",
      [
        "Герои Меча и Магии III",
        "Call of Duty",
        "Age of Empires",
        "Command & Conquer",
      ],
      0,
      images[9],
    ],
    [
      "В какой игре главного героя звали Gordon Freeman?",
      ["SIBERIA", "Dark Mirror", "Half-Life", "Jedi Knight Academy"],
      2,
      images[9],
    ],
    [
      "Первая RPG игра из представленных?",
      ["Diablo", "Gothic", "Lineage", "World of Warcraft"],
      0,
      images[9],
    ],
    [
      "Какой из представленных шутеров появился раньше?",
      ["Unreal Tournament 3", "Counter Strike 1.3", "Quake 3 Arena", "Doom 3"],
      2,
      images[9],
    ],
  ],
  [
    [
      "На обложке какой FIFA изображен Mbappe?",
      ["FIFA 19", "FIFA 21", "FIFA 20", "FIFA 18"],
      1,
      images[15],
    ],
    [
      "Какой игре принадлежат эти слова: “крипер”, “верстак”, “свинозомби”?",
      ["Minecraft", "Cyberpunk", "Plants vs Zombies", "S.T.A.L.K.E.R."],
      0,
      images[15],
    ],
    [
      "Откуда эти локации: Брошенные башни, Подлый пруд, Колкие ключи?",
      [
        "Яндекс.Навигатор",
        "Fortnite",
        "GTA Online",
        "Assassins Creed Black Flag",
      ],
      1,
      images[15],
    ],
    [
      "Как расшифровывается название игры CS:GO?",
      [
        "Counter-Strike: Game Over",
        "Cold Spike: Global Offensive",
        "Cyber Sniper: Gold Old",
        "Counter-Strike: Global Offensive",
      ],
      3,
      images[15],
    ],
    [
      "Какой из какой из гоночных симуляторов вошёл в ТОП список 2021 года?",
      [
        "NFS Most Wanted",
        "F1 2021",
        "Car Mechanic Simulator 2021",
        "Forza Horizon 4",
      ],
      3,
      images[15],
    ],
  ],
];

const answers = [
  [
    [
      [0, 1],
      images[16],
      "1-0 ответа",
      "Ламер!",
      "Для вас игры не только в прошлом, но и не в настоящем! Скорее залипайте на наш гайд и запилите пару каток. Или скачайте все игры и наверстайте матчасть. Потом пройдите тест заново.",
    ],
    [
      [2, 3],
      images[4],
      "3-2 ответа",
      "Unstoppable!",
      "Вы либо любитель стратегий либо шутеров. Но Вы явно помните свой Pentium 100!",
    ],
    [
      [4, 5],
      images[3],
      "5-4 ответов",
      "OLD'ы здесь!",
      "Вы явно прогуливали школу, пары или работу, чтобы сгонять пару каток.",
    ],
  ],
  [
    [
      [0, 1],
      images[22],
      "1-0 ответа",
      "Spectator!",
      "Игры не твоё. Наблюдение. Вот твоё призвание! Либо ты заблудившийся old, который решил пройти и этот тест.",
    ],
    [
      [2, 3],
      images[13],
      "3-2 ответа",
      "GodLike!",
      "Но есть ощущение, что ты либо не доиграл где-то, либо не досмотрел стримы!",
    ],
    [
      [4, 5],
      images[5],
      "5-4 ответов",
      "Сын маминой подруги!",
      "А кто это у нас топчик? Не показывай результат теста родителям. Твоё время за геймингом может сократиться.",
    ],
  ],
];

const GuidePage = () => {
  return (
    <Layout>
      <Guide>
        <Header
          no={4}
          title="Гайд №5"
          subtitle="Как залипнуть вместе на играх"
        />
        <About3 src={images[12]}>
          <p>
            <strong>It&rsquo;s a&nbsp;final ГАЙД now!</strong>
          </p>
          <p>
            Сейчас бумеры мысленно пропели эту песню в&nbsp;голове, а&nbsp;для
            зумеров надо нажать сюда:
          </p>
          <Audio src={sound} />
          <p>
            Как вы&nbsp;уже догадались с&nbsp;помощью Google-переводчика, это
            наш финальный гайд на&nbsp;тему &laquo;Как залипнуть вместе&raquo;.
            И&nbsp;сегодня спич пойдёт о&nbsp;самом вкусненьком!
          </p>
          <p>Об&nbsp;играх, конечно!</p>
          <p>
            Прежде, чем мы&nbsp;начнем все вместе залипать на&nbsp;топовые игры,
            надо пройти тест на&nbsp;геймера. Готовы? Тогда делаем мышкой
            &laquo;клик-клак&raquo;
          </p>
          <p>и&nbsp;отвечаем на&nbsp;вопросики:</p>
        </About3>

        <Test
          css={css({ marginBottom: [50, 150] })}
          {...{ questions, answers }}
        />

        <Wrapper>
          <TwoOneHow>
            <Quotes>
              <Quote type={1}>
                Приколдесный тест. Я&nbsp;взял рейтинг &laquo;OLD&rsquo;ы
                здесь&raquo;, а&nbsp;ты?
              </Quote>
              <Quote type={2}>
                Ееееее бой! А&nbsp;я&nbsp;сын маминой подруги!
              </Quote>
              <Quote type={1}>Чего!?</Quote>
              <Quote type={2}>
                Не&nbsp;кринжуй. Это мем такой! Сын маминой подруги&nbsp;&mdash;
                это некий собирательный фольклорный образ, не&nbsp;имеющий
                определенного автора, но&nbsp;до&nbsp;боли знакомый всем
                и&nbsp;каждому.
              </Quote>
              <Quote type={1}>Красиво завернул.</Quote>
              <Quote type={2}>Не. Это Ctrl-C Ctrl-V.</Quote>
              <Quote type={1}>
                Ну&nbsp;раз у&nbsp;нас высший балл по&nbsp;теме, то&nbsp;давай
                залипнем на какой-нибудь игре вместе?
              </Quote>
              <Quote type={2}>
                Думал не&nbsp;предложишь! Согл. Го! Сначала предлагаю
                разобраться в жанрах. Их&nbsp;очень много, поэтому я&nbsp;собрал
                инфу по&nbsp;самым популярным на&nbsp;сегодняшний день.
              </Quote>
            </Quotes>
            <Picture>
              <img alt="" src={images[7]} />
            </Picture>
          </TwoOneHow>

          <HalfWrap css={css({ mb: [30, 100] })}>
            <TypeCard>
              <TypeTitle>Аркада</TypeTitle>
              <TypePicture $src={images[19]} />
              <TypeDescription>
                Жанр, который характеризуется коротким по&nbsp;времени,
                но&nbsp;интенсивным игровым процессом.
              </TypeDescription>
            </TypeCard>
            <TypeCard>
              <TypeTitle>Королевская битва</TypeTitle>
              <TypePicture $src={images[14]} />
              <TypeDescription>
                Жанр, сутью которого является битва большого количества игроков
                до&nbsp;последнего выжившего
              </TypeDescription>
            </TypeCard>
            <TypeCard>
              <TypeTitle>РПГ</TypeTitle>
              <TypePicture $src={images[18]} />
              <TypeDescription>
                Жанр, который основан на&nbsp;развитии персонажа
              </TypeDescription>
            </TypeCard>
            <TypeCard>
              <TypeTitle>Симулятор выживания</TypeTitle>
              <TypePicture $src={[images[17]]} />
              <TypeDescription>
                Симулятор жизни, где главной целью является сохранение жизни
                персонажа от&nbsp;окружающих его опасностей.
              </TypeDescription>
            </TypeCard>
            <TypeCard>
              <TypeTitle>Шутер</TypeTitle>
              <TypePicture $src={images[6]} />
              <TypeDescription>
                &laquo;Стрелялка&raquo;, жанр, в&nbsp;котором упор сделан
                на&nbsp;скорость реакции геймера и&nbsp;командное
                взаимодействие.
              </TypeDescription>
            </TypeCard>
          </HalfWrap>

          <TwoOneHow>
            <Quotes>
              <Quote type={2}>
                А&nbsp;теперь, вооружившись новыми знаниями, переходим
                к&nbsp;самим играм. Что тебе нравится из&nbsp;Королевской битвы?
              </Quote>
              <Quote type={1}>
                Ну&nbsp;тут без вариантов! Сейчас у&nbsp;любого в&nbsp;фаворе
                и&nbsp;почёте Fortnite!
              </Quote>
            </Quotes>
            <Picture></Picture>
          </TwoOneHow>

          <Games>
            <Game
              name="Fortnite"
              age="12+"
              genre="Королевская битва"
              reqs="Windows; Xbox; PS; Android; macOS; Nintendo Switch; iOS"
              imgSrc={images[21]}
              quotes={
                <Quote type={2}>
                  Огонь! Уже скачал установочный файл. Пока грузится давай я
                  тебе расскажу про World Of Warcraft! Это RPG просто отвал
                  всего!
                </Quote>
              }
            >
              <p>
                В этой топовой игруле есть много режимов. Ты можешь высадиться
                на остров, побороться за звание лучшего игрока или команды.
                Также залипать с друзьями на концертах или просмотрах фильмов.
                Но самый популярный на сегодня режим - Royal Battle! Здесь
                игроки объединяются, чтобы собирать “лут” (внутриигровые
                ценности/ресурсы, полученные игроками после убийства мобов или
                других игроков или разрушения объектов), который они могут
                использовать для строительства форта днём, а ночью защищаться от
                зомби.
              </p>
              <p>
                Игроки могут строить и редактировать каждую стену своего форта,
                строить лестницы, ловушки, крышу и окна. Местность и карта в
                игре генерируются случайным образом, и игрокам даётся различное
                оружие дальнего боя и ближнего боя. В игре представлено четыре
                различных класса, а именно ниндзя, чужеземец, коммандос и
                строитель. Разные классы имеют разные способности. Можно
                крафтить оружие, а навыки персонажа могут быть настроены через
                улучшения и повышение уровней. Конечно, можно устроить PvPшечку
                (игрок против игрока), которая вмещает до 100 игроков и
                победитель остаётся только один.
              </p>
            </Game>
            <Game
              name="World Of Warcraft"
              age="12+"
              genre="RPG"
              reqs="Windows; macOS"
              imgSrc={images[8]}
              quotes={
                <Quote type={1}>
                  Вкусно. Тут точно можем залипнуть вместе. Пока я на обучение -
                  ты тащишь перса, когда ты занят делами - я смогу продолжить.
                  Схема - топ! Но я бы ещё залип на симуляторе выживания!
                  Minecraft - самое то!
                </Quote>
              }
            >
              <p>
                World Of Warcraft - массовая многопользовательская ролевая
                онлайн-игра, в которой игрок управляет одним игровым персонажем,
                развивает его и прокачивает. Игрок выбирает персонажа и
                исследует виртуальный мир игры, сражается с различными врагами и
                боссами, включая персонажей других игроков; выполняет задания
                неигровых персонажей, участвует в совместном с другими игроками
                прохождении различных карт и сценариев.
              </p>
              <p>
                Успешное выполнение заданий позволяет игроку улучшить
                характеристики персонажа и его снаряжение, что открывает доступ
                к новым, более сложным заданиям. В начале задания можно
                проходить в одиночку, но с увеличением уровня перса появляются
                задания сложнее, где уже нужна команда. В составе группы игроки
                принимают на себя разные роли. Обычно команда состоит из танка,
                лекаря и трёх бойцов: танк должен первым вступать в бой и
                отвлекать на себя врагов, лекарь — восстанавливать потерянное
                танком и бойцами здоровье, а бойцы — наносить как можно больше
                урона врагам и разнести их как можно скорее.
              </p>
            </Game>
            <Game
              name="Minecraft"
              age="6+"
              genre="Симулятор выживания"
              reqs="Windows; Xbox 360; Android; PlayStation 3; Nintendo Switch; Xbox One; PlayStation 4; Raspberry Pi; Wii U; PlayStation Vita"
              imgSrc={images[2]}
              quotes={
                <Quote type={2}>
                  О! Графика как в моих первых играх! Кстати тогда самыми
                  популярными были аркады. Я тут глянул, сейчас Among Us самая
                  топовая в этом жанре. Вот о чём игруля.
                </Quote>
              }
            >
              <p>
                Это просто отдельная вселенная, где ты создаешь абсолютно всё!
                Игрок может построить что угодно из строительных блоков или
                создать структуры в разных средах и ландшафтах. С помощью
                Minecraft можно освоить навыки программирования, улучшить
                аналитические способности и развить свой творческий потенциал.
                Есть две версии для детей 6+ и 13+. Если пользователь младше 13
                лет, то ему будут недоступны некоторые функции.
              </p>
              <p>
                Некоторые прогрессивные преподаватели даже включают игру в
                Майнкафт в свои учебные планы!
              </p>
            </Game>
            <Game
              name="Among Us"
              age="7+"
              genre="Аркада"
              reqs="Windows; Android; Xbox Series X/S; PlayStation 5; Nintendo Switch; Xbox One; PlayStation 4; iOS"
              imgSrc={images[20]}
              quotes={
                <>
                  <Quote type={1}>
                    Да, это крутая игруля! Мы с дноклами часто рубимся на задних
                    партах…. Эээээ, шучу, когда есть свободное время.
                  </Quote>
                  <Quote type={2}>
                    <span role="img" aria-label=":(">
                      😒
                    </span>
                  </Quote>
                  <Quote type={1}>
                    А ты слышал что-нибудь про Overwatch? Это просто пушка! А не
                    твой этот quake 3 или unreal.
                  </Quote>
                  <Quote type={2}>Ты откуда про них знаешь?</Quote>
                  <Quote type={1}>Я твой тест прошёл в начале гайда.</Quote>
                  <Quote type={2}>
                    Вообще-то, Overwatch сделан на базе “Unreal”
                  </Quote>
                </>
              }
            >
              <p>
                Завязка и правила схожи со знаменитой игрой Мафия, но не тут-то
                было. Небольшая группа астронавтов (от 4 до 10 человек)
                оказываются на сломанном корабле. Задача простая. Надо выполнить
                мини-задания, чтобы спастись. Но как говорится: Хьюстон, у нас
                проблема. В рядах космо команды завелись гангстеры, которые
                хотят заполучить корабль и убрать всех ненужных участников игры.
                Каждому герою выпадает свой фронт работы, который надо
                выполнить. Цель антагониста – им в этом помешать. В отличие от
                астронавтов, «гангстерам» не нужно бегать туда-сюда с отвёртками
                – их геймплей целиком и полностью строится на незаметных
                убийствах и саботаже. Косить всех направо-налево, впрочем, не
                выйдет: на каждое действие предусмотрен «кулдаун».
              </p>
            </Game>
            <Game
              name="Overwatch"
              age="12+"
              genre="Шутер"
              reqs="Windows; Nintendo Switch; Xbox One; PlayStation 4"
              imgSrc={images[11]}
              quotes={
                <>
                  <Quote type={1}>Ну тогда го? Создаю катку?</Quote>
                  <Quote type={2}>Го! Я тебя на pvp раскатаю!</Quote>
                  <Quote type={1}>Ты, главное, не агрись потом!</Quote>
                </>
              }
              beforeQuotes={
                <HalfWrap css={css({ marginBottom: [50, 80] })}>
                  <Character
                    imageSrc={characters[1]}
                    gradientFrom="#FFD76F"
                    name="Штурмовики"
                  >
                    Быстро передвигаются и могут наносить немаленький урон, но
                    зачастую обладают малым запасом здоровья.
                  </Character>
                  <Character
                    gradientFrom="#FB8F68"
                    imageSrc={characters[2]}
                    name="Танки"
                  >
                    Большой запас здоровья, но медлительны
                  </Character>
                  <Character
                    gradientFrom="#7CFD34"
                    imageSrc={characters[3]}
                    name="Защитники"
                  >
                    Обороняют объекты, к которым нельзя подпускать врагов.
                  </Character>
                  <Character
                    gradientFrom="#A1F7DC"
                    imageSrc={characters[4]}
                    name="Хилеры"
                  >
                    Помогают союзникам, исцеляя их, давая дополнительные щиты
                    или увеличивая их скорость. Нашёл своё призвание? Тогда бери
                    персонажа и бегом на арену!
                  </Character>
                </HalfWrap>
              }
            >
              <p>
                Главное отличие этой игрушки в том, что здесь 21 уникальный перс
                и никаких сценариев и кампаний! Ты можешь воспользоваться
                мультиплеером или затащить битву с ботами! Кого-то это огорчает,
                а для любителей мяса и безответственной пальбы это то, что надо!
                Здесь именно динамика и игровой процесс на первом месте. Но для
                любителей истории и концепции Blizzard развивает вселенную за
                пределами самой игры. В интернетах можно встретить
                короткометражные мультфильмы и комиксы, посвящённые игре.
                Количество режимов игры впечатляет и обещает долгое погружение в
                неисчисляемые битвы. Разработчики также не стоят на месте и
                постоянно выдают качественные апгрейды! Но главная изюминка в
                том, что персонажи настолько проработаны, что ты можешь найти
                себе по вкусу любого.
              </p>
            </Game>
          </Games>
        </Wrapper>

        <FooterStyled>
          <TwoOne>
            <Description>
              <p>
                <strong>P.S.</strong> Надеемся, что вы так же, как бумер и зумер
                заинтересовались нашим топом игр, и уже нашли тот жанр, в
                котором с удовольствием залипните вместе часок-другой, но не
                больше! Кстати, в большинстве современных игр есть
                дополнительные и очень полезные возможности:
              </p>

              <ul>
                <li>настройки функций общения и конфиденциальности;</li>
                <li>отслеживание времени, проведённого в игре;</li>
                <li>ограничения внутриигровых покупок;</li>
                <li>возможность играть одновременно на разных устройствах.</li>
              </ul>

              <p>Достаточно залезть в настройки игры и немного покопаться.</p>
            </Description>
            <Picture>
              <img alt="" src={images[1]} />
            </Picture>
          </TwoOne>
          <TwoOne>
            <Description>
              <p>
                <strong>Р.P.S.</strong> Вот и подошёл к финалу наш последний
                гайд проекта “Как залипнуть вместе”. За это время словарный
                запас родителей значительно обогатился и омолодился, а дети
                стали больше понимать родителей. А главное - вам теперь точно
                есть над чем залипнуть всем вместе, и, это не может не радовать
                нас!
              </p>
              <p>
                <strong>
                  Будьте ближе друг другу!
                  <br />
                  Уважайте интересы друг друга!
                  <br />
                  Залипайте и кайфуйте вместе!
                  <br />
                  Респект и уважуха, что дочитали до конца каждый гайд!
                </strong>
              </p>
              <p>А мы погнали каточку в Fortnite…</p>
            </Description>
            <Picture>
              <img alt="" src={images[10]} />
            </Picture>
          </TwoOne>
          <FooterBye>Всем BB!</FooterBye>
        </FooterStyled>
        <ReadMore without={5} />
        <SafeKids />
      </Guide>
    </Layout>
  );
};

export default GuidePage;
